/**
 * Hardcoded demo menu data used for the /menu/demo route.
 * Completely isolated — no DB dependency.
 */

import demoBurger from "@/assets/demo-burger.jpg";
import demoPizza from "@/assets/demo-pizza.jpg";
import demoAcai from "@/assets/demo-acai.jpg";
import demoLimonada from "@/assets/demo-limonada.jpg";
import demoSmash from "@/assets/demo-smash.jpg";
import demoPepperoni from "@/assets/demo-pepperoni.jpg";
import demoSuco from "@/assets/demo-suco.jpg";
import demoLogo from "@/assets/demo-logo.png";
import demoCover from "@/assets/demo-cover.jpg";

export const DEMO_SLUG = "demo";

export const demoRestaurant = {
  id: "demo-restaurant",
  name: "Sabor & Arte Bistrô",
  slug: DEMO_SLUG,
  logo_url: demoLogo,
  cover_url: demoCover,
  description: "Culinária autoral com ingredientes frescos e sabor de verdade.",
  address: "Rua das Palmeiras, 120 — Jardins, São Paulo",
  contact_phone: "(11) 99999-0000",
  instagram: "@saboreartesp",
  primary_color: "#e85d04",
  secondary_color: "#faa307",
  background_color: "#fffaf5",
  card_color: "#ffffff",
  text_color: "#1a1a1a",
  muted_text_color: "#6b7280",
  is_paused: false,
  pause_message: null as string | null,
  delivery_fee: 6,
  min_order_value: 30,
  business_hours: {
    monday: { open: "11:00", close: "22:00", enabled: true },
    tuesday: { open: "11:00", close: "22:00", enabled: true },
    wednesday: { open: "11:00", close: "22:00", enabled: true },
    thursday: { open: "11:00", close: "22:00", enabled: true },
    friday: { open: "11:00", close: "23:00", enabled: true },
    saturday: { open: "11:00", close: "23:00", enabled: true },
    sunday: { open: "12:00", close: "20:00", enabled: true },
  },
  ai_waiter_enabled: true,
  ai_waiter_greeting: "Oi! Bem-vindo ao Sabor & Arte! Posso te ajudar a escolher? 😊",
  ai_waiter_recommendation_text: "🔥 Um dos mais pedidos",
};

export const demoCategories = [
  {
    id: "demo-cat-1",
    name: "Lanches Artesanais",
    items: [
      {
        id: "demo-item-1",
        name: "Burger Artesanal",
        description: "Blend de angus 180g, queijo cheddar, bacon crocante e molho especial da casa.",
        price: 32.9,
        image_url: demoBurger,
        category_id: "demo-cat-1",
        badge: "Popular",
        discount_percent: null,
        extras: [
          { id: "demo-ext-1", name: "Bacon extra", price: 5 },
          { id: "demo-ext-2", name: "Ovo", price: 3 },
        ],
        is_available: true,
      },
      {
        id: "demo-item-5",
        name: "Smash Burger Duplo",
        description: "Dois blends smash de 90g, cheddar derretido, cebola caramelizada e picles.",
        price: 38.9,
        image_url: demoSmash,
        category_id: "demo-cat-1",
        badge: "Novo",
        discount_percent: null,
        extras: [],
        is_available: true,
      },
    ],
  },
  {
    id: "demo-cat-2",
    name: "Pizzas",
    items: [
      {
        id: "demo-item-2",
        name: "Pizza Margherita",
        description: "Molho de tomate San Marzano, mozzarella de búfala e manjericão fresco.",
        price: 45,
        image_url: demoPizza,
        category_id: "demo-cat-2",
        badge: null,
        discount_percent: 10,
        extras: [
          { id: "demo-ext-3", name: "Borda recheada", price: 8 },
        ],
        is_available: true,
      },
      {
        id: "demo-item-6",
        name: "Pizza Pepperoni",
        description: "Molho de tomate, mozzarella, pepperoni artesanal e orégano.",
        price: 49.9,
        image_url: demoPepperoni,
        category_id: "demo-cat-2",
        badge: null,
        discount_percent: null,
        extras: [],
        is_available: true,
      },
    ],
  },
  {
    id: "demo-cat-3",
    name: "Açaí & Doces",
    items: [
      {
        id: "demo-item-3",
        name: "Açaí Bowl",
        description: "Açaí cremoso com granola, banana, morango e mel orgânico.",
        price: 22,
        image_url: demoAcai,
        category_id: "demo-cat-3",
        badge: "Novo",
        discount_percent: null,
        extras: [
          { id: "demo-ext-4", name: "Leite ninho", price: 4 },
          { id: "demo-ext-5", name: "Paçoca", price: 3 },
        ],
        is_available: true,
      },
    ],
  },
  {
    id: "demo-cat-4",
    name: "Bebidas",
    items: [
      {
        id: "demo-item-4",
        name: "Limonada Suíça",
        description: "Limão siciliano batido com leite condensado e gelo.",
        price: 14,
        image_url: demoLimonada,
        category_id: "demo-cat-4",
        badge: null,
        discount_percent: null,
        extras: [],
        is_available: true,
      },
      {
        id: "demo-item-7",
        name: "Suco Natural de Laranja",
        description: "500ml de suco de laranja espremido na hora.",
        price: 12,
        image_url: demoSuco,
        category_id: "demo-cat-4",
        badge: null,
        discount_percent: null,
        extras: [],
        is_available: true,
      },
    ],
  },
];

export const demoCombos = [
  {
    id: "demo-combo-1",
    name: "Combo Burger + Limonada",
    description: "Burger Artesanal + Limonada Suíça com desconto especial.",
    price: 39.9,
    items: [
      { id: "demo-item-1", name: "Burger Artesanal" },
      { id: "demo-item-4", name: "Limonada Suíça" },
    ],
  },
];

/** Demo best-sellers (ids referenciam itens de demoCategories). */
export const demoTopSellerIds = ["demo-item-1", "demo-item-3", "demo-item-2"];

export const demoCoupons = [
  {
    code: "BEMVINDO15",
    description: "15% de desconto no seu primeiro pedido",
    discount_type: "percentage" as const,
    discount_value: 15,
    min_order_value: 30,
  },
];
